interface ProductBrandV3Props {
  brand: string
}

export default function ProductBrandV3({ brand }: ProductBrandV3Props) {
  return (
    <span className="font-inter text-[12px] text-tertiary font-regular leading-4">
      {brand.charAt(0).toUpperCase() + brand.slice(1).toLowerCase()}
    </span>
  )
}
